import React, { Component } from 'react';
import { Tooltip, Col } from 'reactstrap';

class TooltipLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };
  }

  change = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  render() {
    return (
      <Col className={`detail-text ${this.props.className ? this.props.className : ""}`} xs={this.props.colSize ? this.props.colSize : '4'}>
        <p>{this.props.item.name ? this.props.item.name : ''}
          <span className="tooltip-item">
            <i alt="info-icon" className="pb-1 pl-2 fa fa-info-circle" id={this.props.item.name + this.props.id} />
            <Tooltip placement={this.props.placement ? this.props.placement : 'right'} isOpen={this.state.tooltipOpen} target={this.props.item.name + this.props.id} toggle={this.change}>
              {this.props.item.text}
            </Tooltip>
          </span>
        </p>
      </Col>);
  }
}

export default TooltipLabel;


// WEBPACK FOOTER //
// ./src/components/common/TooltipLabel/TooltipLabel.js